import { Fragment } from "react"
import { format } from 'date-fns'
export const PRPreview = (props) => {

    return (
        <Fragment>
            {
                props.pr &&
                <div>
                    <div>
                        <div class="sr-grid-container">
                            <div class="sr-grid-pr">
                                <div class="sr-grid-header">
                                    <div class="sr-grid-title">
                                        <div class="sr-pr-title">{props.pr.prTitle}</div>
                                        <div class="sr-pr-subtitle">{format(new Date(props.pr.prPostDate), 'PPP')}</div>
                                    </div>
                                    <div class="sr-grid-logo">
                                        <div style={{ textAlign: 'center', marginBottom: '25px' }}><img class="sr-logo" src={props.pr.company.logo} alt={props.pr.company.name} /></div>
                                    </div>
                                </div>
                                {props.pr.prHeaderImage &&
                                    <div style={{ textAlign: 'center' }}>
                                        <img class="sr-pr-header-img" alt="" src={props.pr.prHeaderImage} />
                                    </div>
                                }
                                <div class="sr-pr-body" dangerouslySetInnerHTML={{ "__html": props.pr.prBody }}></div>
                                <div class="sr-pr-subtitle" >About</div>
                                <div dangerouslySetInnerHTML={{ "__html": props.pr.prAbout }}></div>
                                <div class="sr-pr-subtitle">Press Contact</div>
                                <div>{props.pr.prContact.name}</div>
                                <div>{props.pr.prContact.email}</div>
                                <div>{props.pr.prContact.phone}</div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </Fragment>
    )
}